module.exports = __webpack_public_path__ + "static/media/image4.3d31d7e0.png";